import { render, staticRenderFns } from "./LessonVideo.vue?vue&type=template&id=698d2d20&scoped=true&"
import script from "./LessonVideo.vue?vue&type=script&lang=ts&"
export * from "./LessonVideo.vue?vue&type=script&lang=ts&"
import style0 from "./LessonVideo.vue?vue&type=style&index=0&id=698d2d20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698d2d20",
  null
  
)

export default component.exports